






import Vue from 'vue'
export default Vue.extend({
    props: {
        open: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '32px'
        }
    }
})
